<div class="modal-header">
    <h2 class="modal-title">Details</h2>
    <button [attr.guide]="'activity-action-modal-btn-1' + '__' + sanitizedUrl" class="close-btn" (click)="close()">
        <span class="material-icons-outlined">close</span>
    </button>
</div>

<div class="chat-container">
    <div class="message-row" *ngFor="let item of transcript"
        [ngClass]="{'user-row': item.role === 'user', 'agent-row': item.role === 'agent'}">

        <div class="message-bubble"
            [ngClass]="{'user-message': item.role === 'user', 'agent-message': item.role === 'agent'}">
            <div class="message-content">
                {{ item.message }}
            </div>
        </div>

    </div>
</div>